import { createGlobalStyle } from 'styled-components';

const CustomStyles = createGlobalStyle`
  body {
    overflow: unset !important;

    h1, h2, h3, h4, h5, h6 {
      font-weight: 400;
    }
  }  

  .wp-image{
    position: relative;
    border-radius: var(--radius-md);
    overflow:hidden;
  }

  .home-intro{
    position: relative;
        
    & img + div {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: transparent !important;
      background: linear-gradient(180deg, rgba(17, 19, 20, 0) 0%, #111314 100%),
        linear-gradient(
          219deg,
          rgba(66, 72, 79, 0.5) 14.65%,
          rgba(17, 19, 20, 0.5) 93.57%
        );
      opacity: 1 !important;
      pointer-events: none;
    }
  }

  //structure
  body > main{
    contain: paint;
  }

  .style-dark{
    color: white;
    background-color: var(--color-gray100);
  }
  .style-light{
    color: var(--color-primary70);
    background-color: white;
  }

  .page-loading{
    cursor: wait !important;

    & body {
      opacity: 0.6 !important;
      pointer-events: none !important;
    }
  }

  //light gallery
  .lg-backdrop,
  .lg-outer{
    height: 100vh;
  }

  //animations
  .elements_animated {
    position: relative;
    opacity: 0;
    pointer-events: none;

    will-change: transform, opacity;

    &.top,
    &.top-t-bottom {
      transform: translateY(-80px);

      &.in-viewport {
        transform: translateY(0px);
      }
    }
    &.bottom,
    &.bottom-t-top {
      transform: translateY(80px);

      &.in-viewport {
        transform: translateY(0px);
      }
    }
    &.left,
    &.left-t-right {
      transform: translateX(-80px);

      &.in-viewport {
        transform: translateX(0px);
      }
    }
    &.right,
    &.right-t-left {
      transform: translateX(80px);

      &.in-viewport {
        transform: translateX(0px);
      }
    }

    &.zoom-in {
      transform: scale(0.8);

      &.in-viewport {
        transform: scale(1);
      }
    }

    &.zoom-out {
      transform: scale(1.2);

      &.in-viewport {
        transform: scale(1);
      }
    }

    &.masked {
      opacity: 0;
      transition-delay: 1s;
      transition: opacity 0.175s ease;
    }

    &.in-viewport {
      opacity: 1;
    }

    transition: all 0.4s ease-in-out;
  }
  .elements_animated_mask {
    position: absolute;
    top: 0%;
    left: 0%;
    width: 100%;
    height: 100%;
    background-color: white;
    transform-origin: 100% 0;
    z-index: 15;
    transition: transform 1s ease-in-out;

    .in-viewport & {
      transform: scaleX(0);
    }
  }

  //Smooth scroll
  html.lenis {
    height: auto;
  }

  .lenis.lenis-smooth {
    scroll-behavior: auto;
  }

  .lenis.lenis-smooth [data-lenis-prevent] {
    overscroll-behavior: contain;
  }

  .lenis.lenis-stopped,
  .lenis.no-scroll {
    overflow: hidden;
  }

  .lenis.lenis-scrolling iframe {
    pointer-events: none;
  }

  .w-50{
      width: 50% !important;
  }
  .w-75{
      width: 75% !important;
  }

  .w50-mobile-image{
    picture{
      @media only screen and (max-width: responsiveMedia) {
    width: 50% !important;
    }
  }
}

  .link-red{
    strong {a{
      
      color:red;
      text-decoration: underline;
    }}
  }

  .text-white{
color:white;
  }
` as any;

export default CustomStyles;
